import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-no-data-found",
  templateUrl: "./no-data-found.component.html",
  styleUrls: ["./no-data-found.component.scss"],
  standalone: false
})
export class NoDataFoundComponent implements OnInit {
  @Input() message: any;
  constructor() {}

  ngOnInit() {}
}
